import { forwardRef } from "react";
import { DialogTrigger, InnerDialogTrigger } from "../../dialog";
import { jsx as _jsx } from "react/jsx-runtime";
export function InnerAlertTrigger({
  forwardedRef,
  ...rest
}) {
  return /*#__PURE__*/_jsx(DialogTrigger, { ...rest,
    dismissable: false,
    ref: forwardedRef
  });
}
InnerAlertTrigger.defaultElement = InnerDialogTrigger.defaultElement;
export const AlertTrigger = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerAlertTrigger, { ...props,
  forwardedRef: ref
}));